export default __webpack_public_path__ + "86f0aa32970b6eec39f555e4022936b9.svg";